import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import * as moment from 'moment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierService } from 'angular-notifier';
import { ValidateCCardNumber, ValidateIsExpiry, validateAllZeros, validateAllCCZeros } from 'src/app/shared/ccard.validator';
import { CustomerService } from 'src/app/services/customer.service';
@Component({
  selector: 'app-ar-customer-transaction',
  templateUrl: './ar-customer-transaction.component.html',
  styleUrls: ['./ar-customer-transaction.component.scss']
})
export class ArCustomerTransactionComponent implements OnInit {
  private notifier2: NotifierService;
  transactionType;
  tranReservationId;
  paymentTransData = [];
  chequeForm: FormGroup;
  creditCardForm: FormGroup;
  transactionChangeForm: FormGroup;

  activeTab;

  submitted = false;


  constructor(
    private spinner: NgxSpinnerService,
    notifierService2: NotifierService,
    private route: ActivatedRoute,
    private router: Router,
    private arService: ArService,
    private authService: AuthenticationService,
    private arCustomerService: CustomerService) {
    // this.activeTab = this.route.snapshot.paramMap.get('tab');
    this.notifier2 = notifierService2;
    this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    //this.maskUSPhone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

    this.maskDate = [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    this.maskCreditCard = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

    this.modelWithValue = '5554441234'

    this.maskUSPhone = [/\d/, /\d/, /\d/, /\d/];

    this.activeTab = this.route.snapshot.paramMap.get('tid');

    // console.log( this.route.snapshot.paramMap.get('tid'));
  }

  ngOnInit() {
    this.tranReservationId = this.route.snapshot.paramMap.get('id');
    this.getTransactionByID();
    this.initAddtransactionChangeForm();
    localStorage.setItem('arCTActiveTab', this.activeTab);
  }
  initAddChequeForm() {
    let st = moment().format('MM/DD/YYYY');
    this.chequeForm = new FormGroup({
      chequeNumber: new FormControl('', Validators.compose([Validators.required])),
      date: new FormControl(st, Validators.compose([Validators.required])),
      notes: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  initAddCreditCardForm() {
    let st = moment().format('MM/DD/YYYY');
    this.creditCardForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      creditCardNo: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[0-9 ]{15,19}$'), ValidateCCardNumber, validateAllCCZeros])),
      expireMonthYear: new FormControl('', Validators.compose([Validators.required, ValidateIsExpiry])),
      cvv: new FormControl('', Validators.compose([Validators.required, validateAllZeros])),
    });
  }

  validation_messages = {
    'notes': [
      { type: 'required', message: 'Notes is required.' }
    ],
    'name': [
      { type: 'required', message: 'Card Name is required.' }
    ],
    'creditCardNo': [
      { type: 'required', message: 'Credit card number is required.' },
      { type: 'invaliCCNumber', message: 'Credit card number is invalid.' },
      { type: 'validateAllCCZeros', message: 'Credit card number can not be all zeros' }
    ],
    'expireMonthYear': [
      { type: 'required', message: 'Expire Date is required.' },
      { type: 'pattern', message: 'Expire Date must be MM/YYYY format.' },
      { type: 'isExpiryInvalid', message: 'Expire Date is invalid.' }
    ],
    'cvv': [
      { type: 'required', message: 'CVV is required.' },
      { type: 'validateAllZeros', message: 'CVV can not be all zeros' }
    ],
    'chequeNumber': [
      { type: 'required', message: 'Cheque Number is required.' }
    ]
  }

  get formControls(): any {
    return this.creditCardForm.controls;
  }

  get checkFormControls(): any {
    return this.chequeForm.controls;
  }

  validateCreditDetails() {
    if (this.formControls.name.errors) {
      this.notifier2.notify('warning', 'Please enter Card Name');
      return false;
    }
    if (this.formControls.creditCardNo.errors) {
      this.notifier2.notify('warning', 'Please enter Credit card number');
      return false;
    }
    if (this.formControls.expireMonthYear.errors) {
      this.notifier2.notify('warning', 'Please enter Expire Date');
      return false;
    }
    if (this.formControls.cvv.errors) {
      this.notifier2.notify('warning', 'Please enter CVV');
      return false;
    }

  }

  validateCheckDetails() {
    if (this.checkFormControls.chequeNumber.errors) {
      this.notifier2.notify('warning', 'Please enter Cheque Number');
      return false;
    }
    if (this.checkFormControls.notes.errors) {
      this.notifier2.notify('warning', 'Please enter Notes');
      return false;
    }
  }

  initAddtransactionChangeForm() {
    this.transactionChangeForm = new FormGroup({
      subTotal: new FormControl('', Validators.compose([Validators.required])),
      taxes: new FormControl('', Validators.compose([Validators.required])),
      totalAmount: new FormControl('', Validators.compose([Validators.required]))
    });
  }


  initUpdateChangeAmountForm() {
    this.transactionChangeForm = new FormGroup({
      subTotal: new FormControl(this.paymentTransData[0].TRANSACTION_SUBTOTAL, Validators.compose([Validators.required])),
      taxes: new FormControl(this.paymentTransData[0].TRANSACTION_TAXES, Validators.compose([Validators.required])),
      totalAmount: new FormControl(this.paymentTransData[0].TRANSACTION_TOTAL, Validators.compose([Validators.required]))
    });
  }



  taxSlab;
  getTaxSlab(data) {
    this.arService.getTaxSlabByStation(data).subscribe(async res => {
      if (res['status']) {
        this.taxSlab = res['result'][0].TAX_SLAB;
      } else {
        //  console.log(res['message']);
      }
    }, err => {

      console.log(err);
    })
  }


  station;
  async getTransactionByID() {
    this.spinner.show();
    if (this.tranReservationId) {
      await this.arCustomerService.toBeBilledCustomerTransaction(this.tranReservationId).subscribe(async res => {
        if (res['status'] && res['result'].length > 0) {
          this.spinner.hide();
          this.paymentTransData = res['result'];
          this.transactionType = this.paymentTransData[0].TRANSACTION_TYPE;
          await this.initUpdateChangeAmountForm();
          this.station = this.paymentTransData[0].STATION;
          const data = {
            station: this.station
          }

          await this.getTaxSlab(data);
          if (this.paymentTransData[0].TRANSACTION_TYPE == 'Credit Card') {
            this.initAddCreditCardForm();
          } else {
            this.initAddChequeForm();
          }
        }
      });
    }
  }

  getMultilTransactionsByID() {
    //  this.spinner.show();
    this.arService.getMultipleTransactionByResId(this.tranReservationId).subscribe(async res => {
      // this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        //console.log(res['result']);
      }
    });
  }


  get f(): any {
    return this.transactionChangeForm.controls;
  }


  public myModel: string;
  public modelWithValue: string;

  public mask: Array<string | RegExp>;
  public maskUSPhone: Array<string | RegExp>;
  public maskDate: Array<string | RegExp>;
  public maskCreditCard: Array<string | RegExp>;

  submitTransactionOfPayment(formData) {
    this.spinner.show();
    this.submitted = true;

    if (this.paymentTransData[0].TRANSACTION_TYPE === 'Credit Card') {
      this.validateCreditDetails();
      this.creditCardForm.markAllAsTouched();

      if (this.creditCardForm.invalid) {
        this.spinner.hide();
        return;
      }

      // Clean credit card number and parse expiration date
      let ccNumber = formData.creditCardNo.replace(/\s/g, '');
      let [expireMonth, expireYear] = formData.expireMonthYear.split("/");
      const expWithYear = expireYear + expireMonth;

      // Simplified credit card brand mapping
      const cardBrandMapping = {
        'maestro': 'MA',
        'visa': 'VI',
        'mastercard': 'MC',
        'amex': 'AX',
        'dinersclub': 'DN',
        'discover': 'DS',
        'unionpay': 'CU',
        'jcb': 'JC'
      };
      let ccBrand = cardBrandMapping[formData.ccBrand] || 'MC'; // Default to 'MC' if brand not found

      let amount = this.paymentTransData[0].TRANSACTION_TOTAL - this.paymentTransData[0].BLOCKED_AMOUNT;
      let finaliseAmount;

      if (Number.isInteger(amount)) {
        finaliseAmount = amount
      } else {
        // Calculate the decimal part
        let decimalPart = amount - Math.floor(amount);

        if (decimalPart < 0.26) {
          // If the decimal part is less than 0.26, add 0.26 to the whole number part
          finaliseAmount = Math.floor(amount) + 0.26;
        } else {
          // If the decimal part is 0.26 or greater, keep the amount as is (rounded to 2 decimal places)
          finaliseAmount = amount;
        }

        // Round to two decimal places
        finaliseAmount = Number(finaliseAmount.toFixed(2));
      }
      let postData = {
        transactionType: this.paymentTransData[0].TRANSACTION_TYPE,
        ccAccountNum: ccNumber,
        ccCardVerifyNum: formData.cvv,
        ccExp: expWithYear,
        amount: finaliseAmount,
        resId: this.paymentTransData[0].RESID,
        country: this.paymentTransData[0].CURRENCY_FLAG,
        ccBrand: ccBrand
      };
      this.arCustomerService.creditCardPaymentsOfTransaction(postData).subscribe(async res => {

        if (res['status']) {
          await this.getTransactionByID();
        } else {
          this.notifier2.notify('danger', res['message']);
        }
        this.spinner.hide();
      }, err => {
        this.spinner.hide();
        this.notifier2.notify('danger', err.message);
        console.log(err)
        //console.error(err);
      });
    }
  }


  // submitTransactionOfPayment(formData) {
  //   this.spinner.show();
  //   this.submitted = true;
  //   if (this.paymentTransData[0].TRANSACTION_TYPE == 'Credit Card') {
  //     this.validateCreditDetails();
  //     this.creditCardForm.markAllAsTouched();
  //     if (this.creditCardForm.invalid) {
  //       return;
  //     }
  //     let ccNumber = formData.creditCardNo.replace(/\s/g, '');
  //     var ccExp = formData.expireMonthYear.split("/");
  //     const expWithYear = ccExp[1] + ccExp[0];
  //     let ccBrand = 'MC';
  //     // if(formData.ccBrand == 'maestro'){
  //     //     ccBrand = 'MA'
  //     // } else if(formData.ccBrand == 'visa'){
  //     //   ccBrand = 'VI'
  //     // }else if(formData.ccBrand == 'mastercard'){
  //     //   ccBrand = 'MC'
  //     // }else if(formData.ccBrand == 'amex'){
  //     //   ccBrand = 'AX'
  //     // }else if(formData.ccBrand == 'dinersclub'){
  //     //   ccBrand = 'DN'
  //     // }else if(formData.ccBrand == 'discover'){
  //     //   ccBrand = 'DS'
  //     // }else if(formData.ccBrand == 'unionpay'){
  //     //   ccBrand = 'CU'
  //     // }else if(formData.ccBrand == 'jcb'){
  //     //   ccBrand = 'JC'
  //     // }
  //     let amount = (this.paymentTransData[0].TRANSACTION_TOTAL - this.paymentTransData[0].BLOCKED_AMOUNT) + '';
  //     let roundedAmount = parseFloat(amount).toFixed(2);
  //     let finalAmount = parseFloat(roundedAmount);
  //     let postData = {
  //       transactionType: this.paymentTransData[0].TRANSACTION_TYPE,
  //       ccAccountNum: ccNumber,
  //       ccCardVerifyNum: formData.cvv,
  //       ccExp: expWithYear,
  //       amount: finalAmount,
  //       resId: this.paymentTransData[0].RESID,
  //       country: this.paymentTransData[0].CURRENCY_FLAG,
  //       ccBrand: ccBrand
  //     }

  //     this.arCustomerService.creditCardPaymentsOfTransaction(postData).subscribe(async res => {
  //       if (res['status']) {
  //         await this.getTransactionByID();
  //         this.spinner.hide();
  //       } else {
  //         this.notifier2.notify('danger', res['message']);
  //         this.spinner.hide();
  //       }
  //     }, err => {
  //       this.spinner.hide();
  //       this.notifier2.notify('danger', err.message)
  //       console.log(err);
  //     })
  //   }
  // }

  amountChangeStatus = false;
  amountChangeCheckingFn(value) {

    // console.log("TaxSlab : ",  this.taxSlab);

    const aa = parseFloat(this.paymentTransData[0].TRANSACTION_SUBTOTAL);
    let formSubtotal = parseFloat(value);
    // console.log(event.value)
    if (aa && formSubtotal !== aa) {

      // changed amount.
      this.amountChangeStatus = true;
      let taxCal = formSubtotal * (this.taxSlab / 100);

      let totalAmount = formSubtotal + taxCal;


      this.transactionChangeForm.controls['taxes'].setValue(taxCal);
      this.transactionChangeForm.controls['totalAmount'].setValue(totalAmount);

      // console.log('Changed:',aa  + " to "  +  formSubtotal + " ---> Tax: " + taxCal + " Toatal Amount : " + totalAmount);

    } else {
      //not changed...
      //console.log('Not Changed:',aa , formSubtotal);
      let taxCal = formSubtotal * (this.taxSlab / 100);

      let totalAmount = formSubtotal + taxCal;


      this.transactionChangeForm.controls['taxes'].setValue(taxCal);
      this.transactionChangeForm.controls['totalAmount'].setValue(totalAmount);


    }
  }

  captureCCardAmount(data) {
    this.spinner.show();
    const ccData = {
      RESID: data.RESID,
      TXREFNUM: data.TXREFNUM,
      CURRENCY_FLAG: data.CURRENCY_FLAG
    }
    this.arCustomerService.paymentMarkAndCaptureByTReference(ccData).subscribe(async res => {
      if (res['status']) {
        this.notifier2.notify('success', 'Payment captured successfully');
        setTimeout(r => {
          this.router.navigateByUrl("home/customer-dashboard");
        }, 3000)
        this.spinner.hide();
      } else {
        this.notifier2.notify('warning', res['message']);
        setTimeout(r => {
          this.router.navigateByUrl("home/customer-dashboard");
        }, 3000)
        this.spinner.hide();
      }
    });
  }


  onBack() {
    this.router.navigateByUrl("home/customer-dashboard");
  }

  getTime(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }
  getTimeFormat(date) {
    return moment.utc(date).format('MM/DD/YY, hh:mm a');
  }
  getDateFormat(date) {
    return moment.utc(date).format('MM/DD/YY');
  }
}
